import React from 'react';
import { Layout } from '../Layout';

export const Results: React.FC = () => {
    return (
        <Layout>
            <div>
                <h1>This is a default Results page!!!</h1>
            </div>
        </Layout>
    )
};